<template>
  <section class="page-container">
    <article class="page-contents-wrap">
      <sub-title :text="'회사 정보'" />
      <div class="page-content">
        <div class="item-row-container">
          <div class="item-wrap">
            <div class="item-title">회사명</div>
            <div class="item-content">
              <input type="text" ref="siteName" v-model="regInfo.siteName" />
            </div>
          </div>
          <div class="item-wrap">
            <div class="item-title">등급</div>
            <div class="item-content">
              <select class="reqMember" name="partnerType" @input="getPartnerType" disabled>
                <option value="senior">시니어</option>
              </select>
            </div>
          </div>
        </div>
        <div class="item-row-container">
          <div class="item-wrap">
            <div class="item-title">아이디</div>
            <div class="item-content">
              <input type="text" ref="siteId" v-model="regInfo.siteId" />
            </div>
          </div>
          <div class="item-wrap">
            <div class="item-title">연락처</div>
            <div class="item-content">
              <input type="text"/>
            </div>
          </div>
        </div>
        <div class="item-row-container">
          <div class="item-wrap">
            <div class="item-title">비밀번호</div>
            <div class="item-content">
              <input type="password" v-model="regInfo.sitePass" />
            </div>
          </div>
          <div class="item-wrap"></div>
        </div>
        <div class="item-row-container">
          <div class="item-wrap">
            <div class="item-title">비밀번호 확인</div>
            <div class="item-content">
              <input type="password" v-model="passCheck" />
            </div>
          </div>
          <div class="item-wrap"></div>
        </div>
      </div>
    </article>
    <article class="page-contents-wrap">
      <sub-title :text="'알 잔고'" />
      <div class="page-content">
        <div class="item-row-container">
          <div class="item-wrap">
            <div class="item-title">알 한도</div>
            <div class="item-content">
              <div class="onlyNum">
                <input type="number" />
              </div>
              <!-- <span>&nbsp; &lt;= KRW 200,000,000</span> -->
            </div>
          </div>
          <div class="item-wrap">
            <div class="item-title">수수료율(%)</div>
            <div class="item-content">
              <select>
                <template v-for="(n, index) in 201" :key="index">
                  <option>{{ index * 0.5 }}</option>
                </template>
              </select>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article class="page-contents-wrap">
      <sub-title :text="'커미션'">
        <div>
          <input type="number" class="mr-5" @change="totalRateLimit" v-model="controlRate" />
          <button type="button" class="btn-layout btn-blue mr-5" @click="rateAllChange">일괄적용</button>
          <button type="button" class="btn-layout btn-blue redo">
            <i class="fas fa-redo"></i>
          </button>
        </div>
      </sub-title>
      <div class="page-content s-content-wrap wrapper-contents itemz">
        <template v-for="(item, index) in rateList" :key="item.gameType">
          <div class="s-content">
            <div class="title">
              <span>{{ item.gameName }}</span>
            </div>
            <div class="content">
              <div class="rollcount">

                <input type="number" @change="rateLimit(index)" v-model="item.pointRate" />
                <div>
                  <button type="button" @click="increase(index)">
                    <i class="fas fa-angle-up"></i>
                  </button>
                  <button type="button" @click="decrease(index)">
                    <i class="fas fa-angle-down"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </article>
    <div class="center">
      <btn-regist @click="regist" />
    </div>
  </section>
</template>

<script>
import lodash from "lodash";
import subTitle from "@/components/main/PageSubTitle";
import { getSiteData } from "@/libs/auth-helper";
import BtnRegist from "@/components/ui/BtnRegist";
import { getCode } from "@/api/utils";
import { companyDetail, companyAdd } from "@/api/company";
import { GAME_INFO_LIST } from "@/libs/constants.js";

export default {
  name: "Create",
  components: {
    subTitle,
    BtnRegist
  },
  data() {
    return {
      controlRate: "0.00",
      checkedToggle: false,
      subToggle: false,
      nationList: [],
      commissionDisplay: "all",
      commissionObj: {
        group: [],
        commissionList: []
      },
      rateTypeDefault: "",
      rateType: [],
      betLimitList: [],
      regInfo: {
        siteName: "",
        siteId: "",
        sitePass: ""
      },
      passCheck: "",
      siteInfo: {},
      rateList: [],
      gameList: [],
      maxCreditComma: ""
    };
  },
  methods: {
    async deduplicate(memId) {
      const req = {
        memId: memId
      };
      const res = await companyDetail(req);
      if (!res.data.member) {
        return true;
      } else {
        return false;
      }
    },
    setRateList() {
      this.setRateListDefault();
    },
    setRateListDefault() {
      for (const loop of this.gameListDefault) {
        for (const item of loop.child) {
          if (item.useYn === "N") {
            continue;
          }
          const model = lodash.cloneDeep(this.rateModel);
          model.gameType = item.code;
          model.gameName = item.codeName;
          model.groupCode = item.groupCode;
          model.loop = Number(model.maxPointRate) / this.rateIncrease;
          this.rateList.push(model);
        }
      }
      console.log(this.rateList);
      this.originRate = lodash.cloneDeep(this.rateList);
    },
    totalRateLimit() {
      const n = Number(this.controlRate).toFixed(2);
      if (n >= 100) {
        this.controlRate = (100).toFixed(2);
      } else if (n < 0) {
        this.controlRate = (0).toFixed(2);
      } else {
        this.controlRate = Number(this.controlRate).toFixed(2);
      }
    },
    rateAllChange() {
      const rateList = this.rateList;
      for (const item of rateList) {
        item.pointRate = this.controlRate;
      }
    },
    rateLimit(idx) {
      const n = Number(this.rateList[idx].pointRate).toFixed(2);
      if (n >= 100) {
        this.rateList[idx].pointRate = (100).toFixed(2);
      } else if (n < 0) {
        this.rateList[idx].pointRate = (0).toFixed(2);
      } else {
        this.rateList[idx].pointRate = Number(this.rateList[idx].pointRate).toFixed(2);
      }
    },
    increase: function (idx) {
      if (Number(this.rateList[idx].pointRate) === 100) {
        return;
      }
      this.rateList[idx].pointRate = (Number(this.rateList[idx].pointRate) + 0.05).toFixed(2);
    },
    decrease: function (idx) {
      if (Number(this.rateList[idx].pointRate) <= 0) {
        return;
      }
      this.rateList[idx].pointRate = (Number(this.rateList[idx].pointRate) - 0.05).toFixed(2);
    },
    getSiteInfo() {
      const siteInfoCookie = getSiteData();
      if (siteInfoCookie) {
        const siteInfo = JSON.parse(siteInfoCookie);
        return siteInfo;
      }
    },
    // setMaxCredit(e) {
    //   const code = e.keyCode;
    //   if ((code > 47 && code < 58) || e.ctrlKey || e.altKey || code === 8 || code === 9 || code === 46) {
    //     if (code > 47 && code < 58) {
    //       const split = e.target.value.split(",");
    //       let text = "";
    //       for (const item of split) {
    //         text += "" + item;
    //       }
    //       console.log(text);
    //       e.target.value = this.numberWithCommas(text);
    //     }
    //     return;
    //   }
    //   e.preventDefault();
    // },
    async regist() {
      const req = lodash.cloneDeep(this.regInfo);
      // const overlapChk = await this.deduplicate(req.memId);
      // if (!overlapChk) {
      //   alert("중복된 아이디 입니다.");
      //   this.$refs.memId.focus();
      //   return;
      // }

      // if (req.maxCredit > 200000000) {
      //   alert("최대 크레딧 한도를 확인해주세요.");
      // }
      // req.rateList = [];
      // const rateList = lodash.cloneDeep(this.rateList);
      // for (const item of rateList) {
      //   if (item.useYn) {
      //     item.useYn = "Y";
      //   } else {
      //     item.useYn = "N";
      //   }
      //   if (item.betYn) {
      //     item.betYn = "Y";
      //   } else {
      //     item.betYn = "N";
      //   }
      //   const rateModel = {
      //     gameType: item.gameType,
      //     pointRate: item.pointRate,
      //     useYn: item.useYn,
      //     betYn: item.betYn
      //   };
      //   req.rateList.push(rateModel);
      // }

      const res = await companyAdd(req);
      if (res.resultCode === "0") {
        alert("컴퍼니 등록완료");
        this.$router.go();
      } else {
        alert("컴퍼니 등록 실패. 다시 시도해주세요.");
      }
    }
  },
  watch: {
    // regInfo: {
    //   handler(target) {
    //     console.log(target.maxCredit);
    //     if (target.maxCredit >= 200000000) {
    //       target.maxCredit = 200000000;
    //     }
    //   },
    //   deep: true
    // }
  },
  async created() {
    await this.setGameList();
    this.setRateList();
    this.siteInfo = await this.getSiteInfo();
  }
};
</script>

<style scoped>
table {
  width: 100%;
}
.content-wrap {
  margin-bottom: 40px;
}

.content {
  font-size: 0.75em;
}
.content td {
  padding: 4px 10px;
  height: 35px;
  box-sizing: border-box;
  border-bottom: solid 1px #ddd;
}
.input-title {
  font-weight: 700;
  text-align: left;
  width: 9%;
}
.input-value {
  width: 20%;
}
.inner {
  display: flex;
  align-items: center;
}
select {
  padding: 5px;
  font-size: 0.9em;
  height: 26px;
}
/* input {
  border: 1px solid #18698b;
  border-radius: 3px;
} */
.mainId {
  margin-right: 5px;
}
.innerWrap {
  padding: 4px 10px;
  height: 35px;
  max-height: 35px;
  box-sizing: border-box;
  display: flex;
  align-content: center;
  border-bottom: solid 1px #ddd;
}
/* 라디오 */
.box-ui-radio {
  font-size: 1em;
  display: flex;
  justify-content: center;
  margin-right: 10em;
}
.box-ui-radio:last-child {
  margin-right: 0;
}
input[type="radio"] {
  display: none;
}
input[type="radio"] + label {
  display: flex;
  align-items: center;
}
input[type="radio"] + label > .circle {
  display: block;
  width: 17px;
  height: 17px;
  box-sizing: border-box;
  border: 2px solid #394357;
  border-radius: 100%;
  margin-right: 5px;
}
input[type="radio"]:checked + label > .circle {
  border: 5px solid #394357;
}

/* 체크박스 */
.box-ui-check {
  font-size: 1em;
  display: flex;
  justify-content: center;
}
input[type="checkBox"] {
  display: none;
}
input[type="checkbox"] + label {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
input[type="checkbox"] + label > i {
  border: 2px solid #394357;
  background: #fff;
  border-radius: 5px;
  padding: 2px;
  font-size: 10px;
  color: #fff;
  margin-right: 4px;
}
input[type="checkbox"]:checked + label > i {
  background: #394357;
}

.hidenContent {
  display: none;
  align-items: center;
  width: fit-content;
}
.hidenContent.show {
  display: flex;
}
.subContent-wrapper {
  width: 100%;
  height: auto;
  max-height: unset;
  padding: 2px 5px;
}
.subContent-wrap {
  width: 100%;
}
.subContent-wrap .subTitle {
  font-size: 1.2em;
  font-weight: 800;
  background: #e9a198;
  color: #fff;
  padding: 8px 10px;
  position: relative;
}
.subContent {
  max-height: 0;
  overflow: hidden;
}
.subContent.open {
  padding: 5px 5px;
  max-height: unset;
}
.subContent th,
.subContent td {
  border: 1px solid #fff;
  padding: 4px 10px;
  height: 35px;
  box-sizing: border-box;
}
.subContent th {
  background: #ffe5de;
  color: #000;
  font-weight: 700;
}
th.subTitleHead {
  background: transparent;
  color: #000;
  text-align: left;
  border-bottom: solid 1px #ddd;
}
.subTable-title {
  background: #ffe5de;
  font-weight: 800;
  padding: 8px 8px;
}
.btn-subConShow {
  position: absolute;
  border: 2px solid #df4946;
  border-radius: 3px;
  padding: 4px;
  background: #df4946;
  color: #fff;
  font-size: 0.8em;
  transform: translateY(-50%);
  top: 50%;
  right: 8px;
  cursor: pointer;
}
.btn-subConShow:hover {
  background: #fff;
  color: #df4946;
}
.textCenter {
  text-align: center;
  font-weight: 700;
  padding: 4px 0;
}
.remark {
  font-weight: 800;
  color: red;
}
.notice {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: red;
}
.notice i {
  font-weight: 800;
  font-size: 1.5em;
  margin-right: 10px;
}
.notice > span {
  font-size: 1em;
  font-weight: 800;
}
.s-content {
  border: 0;
}
/* title select */
.title-select-wrap {
  font-size: 12px;
  margin: 5px;
  min-width: 75px;
  max-width: 75px;
  display: flex;
  flex-direction: column;
  border: 1px solid #afafaf;
}
.title-select-title {
  padding: 5px 4px;
  box-sizing: border-box;
  text-align: center;
  background: #298cb3;
  color: #fff;
  font-weight: 700;
  border-radius: 6px 6px 0 0;
}
.title-select-content {
  border: 1px solid #9e9e9e;
  border-top: 0;
  border-radius: 0 0 6px 6px;
}
.title-select-item {
  box-sizing: border-box;
  padding: 4px;
  font-size: 1em;
  width: 100%;
  border: 0;
}
.center button {
  margin: 10px 0 70px;
  font-size: 14px;
  width: 130px;
  height: 45px;
}
.center {
  text-align: center;
}
.item-content input {
  width: 100%;
  max-width: 190px;
  border: 1px solid #e6e6f6;
}
.item-content select {
  font-weight: 500;
  width: 100%;
  border: 1px solid #e6e6f6;
  height: 30px;
  max-width: 190px;
  font-size: 14px;
  padding: 0 10px;
}
.userInfo-select {
  font-weight: 500;
  padding: 2px 5px;
  height: 21px;
  width: 100%;
}
.s-content > .content {
  display: flex;
  font-size: 1em;
  height: calc(56px - 26px);
}
.s-content-wrap {
  padding:20px 0;
  max-height: 370px;
}
.s-content {
  flex: 1 1 16%;
  border: 0;
  margin: 10px;
}
.s-content > .title {
  margin-bottom: 0;
  white-space: nowrap;
  font-size: 14px;
  color: #0c4695;
  font-weight: 500;
}
.itemz .s-content {
  flex: 0 0 23.6%;
    max-width: unset;
    margin: 0;
    display: flex;
    padding: 10px 65px;
    border-right: 1px solid #f2f2fa;
    box-sizing: border-box;
    justify-content: space-between;
}
.itemz .s-content .content select {
  border-top: 0;
  border-radius: 0 0 6px 6px;
  height: 30px;
  text-align: center;
}
.rollcount {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border:1px solid #e6e6f6;
  /* border-radius: 0 0 6px 6px; */
}
.rollcount > div{
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.rollcount button {
  color: #676767;
  font-weight: bold;
  width:15px;
  height:15px;
  border:1px solid #e6e6f6;
  font-size: .9em;
  background: #fff;
}
.rollcount span {
  font-weight: bold;
  color: #212121;
  font-size: 1em;
}
.center button {
  width: 205px;
height: 41px;
background-color: #126ae2;
color:#fff;
font-size:16px;
font-weight: 500;
border-radius: 0;
}
.center {
  text-align: center;
}
.rollcount > input[type="number"] {
  width: 45px;
  text-align: center;
  border:0px;
  height:28px;
  /* border: none; */
}
.page-contents-wrap{
  margin-bottom:20px;
}
</style>
